import { render, staticRenderFns } from "./TeamProfileCard.vue?vue&type=template&id=ad6c1056&scoped=true&"
import script from "./TeamProfileCard.vue?vue&type=script&lang=ts&"
export * from "./TeamProfileCard.vue?vue&type=script&lang=ts&"
import style0 from "./TeamProfileCard.vue?vue&type=style&index=0&id=ad6c1056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6c1056",
  null
  
)

export default component.exports